import React, { useEffect } from "react";

const Toast = ({ state, children, duration = 3000, onClose }) => {
    useEffect(() => {
        let timer;

        if (state && duration > 0 && onClose) {
            timer = setTimeout(() => {
                onClose();
            }, duration);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [state, duration, onClose]);

    return (
        <div className={`fixed right-4 w-60 h-auto bg-primary-tw py-4 rounded-lg border ${state ? 'bottom-6 opacity-100 z-[9999999999999] max-lg:bottom-2' : '-bottom-20 opacity-0 z-0'} transition-all delay-150 ease-in-out max-md:w-full max-md:right-0 p-2`}>
            {children}
        </div>
    );
};

export default React.memo(Toast);